import { SelectionNamePieces } from './internal';
export class SelectionNameRomanization extends SelectionNamePieces {
    getMethod() {
        return this.get("TYPE" /* Tag.Type */);
    }
}
//# sourceMappingURL=SelectionNameRomanization.js.map